export namespace GoogleAuth {
  function corsImport(_s: string): Promise<Api> {
    return new Promise((resolve, reject) => {
      const script = document.createElement("script");
      script.setAttribute("src", "https://accounts.google.com/gsi/client");
      // @ts-ignore
      script.onload = () => resolve(google);
      script.onerror = () => reject(new Error("Could not load Google sign-in"));
      document.head.appendChild(script);
    });
  }

  type Client = {
    requestCode: () => void;
  };

  type ClientCodeResponse = {
    code?: Option<string>;
    error?: Option<string>;
  };

  type Api = {
    accounts: {
      oauth2: {
        initCodeClient: (config: {
          client_id: string;
          scope: string;
          ux_mode: "popup";
          select_account: boolean;
          login_hint?: Option<string>;
          include_granted_scopes: boolean;
          error_callback: (error: { type: string }) => void;
          callback: (response: ClientCodeResponse) => void;
        }) => Client;
      };
    };
  };

  async function load(): Promise<Api> {
    return await corsImport("https://accounts.google.com/gsi/client");
  }

  export async function login(
    clientId: string,
    scope: string[],
    options: { hint?: Option<string> } = {},
  ): Promise<string> {
    const google = await load();
    return new Promise((resolve, reject) => {
      // https://developers.google.com/identity/oauth2/web/guides/use-code-model#popup-mode
      const client = google.accounts.oauth2.initCodeClient({
        client_id: clientId,
        scope: scope.join(" "),
        ux_mode: "popup",
        // Normal sign-in chooses an account; permission upgrades target the linked account.
        select_account: !options.hint,
        login_hint: options.hint,
        include_granted_scopes: true,
        error_callback: () =>
          reject(new Error("Google sign-in popup was closed or blocked")),
        callback: (response) => {
          if (response.error || !response.code) {
            reject(new Error("Google authorization was not granted"));
          } else {
            resolve(response.code);
          }
        },
      });
      client.requestCode();
    });
  }
}
